import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper banner6',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page banner6-page',
    },
    bg: {
      className: 'bg',
      children:
        'https://imm.86links.com/assets/landing/banner/%E8%83%8C%E6%99%AF1.png',
    },
    title: {
      name: 'title',
      children: [
        {
          name: '标题0',
          className: 'banner6-title-item',
          children: '成都经济技术开发区',
        },
      ],
      className: 'banner6-title',
    },
    box: {
      className: 'box',
      children: [
        {
          name: '左边内容',
          className: 'banner6-explain',
          children: '山水龙泉驿 </br> 活力汽车城',
        },
        {
          name: '右边内容',
          className: 'banner6-content',
          children: `幅员面积557平方公里，</br>
              实际服务人口135万人，三大国家级平台所在地。</br>
              2020年，地区生产总值1355.2亿元，</br>
              在全国218家国家级经开区中名列第18位。`,
        },
      ],
    },
    logo: {
      className: 'banner6-logo',
      children:
        'https://imm.86links.com/assets/landing/images/%E7%BC%96%E7%BB%84%204%402x.png',
    },
  },
};
